import Logger from "../lib/logger";
import { money } from "../lib/util.functions";

class ColoTableItem extends HTMLLIElement {
	name = "ColoTableItem";
	abortController;
	quantity = 0;
	price = 0;
	variantID;

	constructor() {
		super();
		/* Logger.info(`${this.name} > constructor`); */
		this.form = this.querySelector("form");
		this.colorVariantPicker =
			this.closest("color-variant-picker") ||
			this.closest(".procion-variant-picker__list");
		this.swatchEl = this.querySelector("[data-pattern-style]");
		this.sizeSelect = this.querySelector("select[data-size]");
		this.quantityInput = this.querySelector("input[data-quantity]");
		this.priceDiv = this.querySelector("div[data-price]");
		this.modal = document.querySelector('dharma-modal[id="swatch-modal"]');
		this.modalImage = this.modal?.querySelector("img");
	}

	connectedCallback() {
		/* Logger.info(`${this.name} > connectedCallback`); */
		this.abortController = new AbortController();
		const { signal } = this.abortController;
		//
		this.form.addEventListener("submit", (e) => e.preventDefault(), { signal });
		this.sizeSelect.addEventListener("change", () => this.onSelect(), {
			signal,
		});
		this.quantityInput.addEventListener("input", () => this.onInput(), {
			signal,
		});
		this.swatchEl.addEventListener("click", () => this.onSwatch(), { signal });
		if (this.quantityInput.value) this.quantity = this.quantityInput.value;
		document.addEventListener("DOMContentLoaded", () => {
			this.onSelect(false);
		});
	}

	disconnectedCallback() {
		/* Logger.info(`${this.name} > disconnectedCallback`); */
		this.abortController.abort();
		this.abortController = null;
	}

	static get observedAttributes() {
		return ["data-reset"];
	}

	get hasTieredPricing() {
		return !!this.dataset.tieredPricing;
	}

	get tieredGroupItem() {
		return this.colorVariantPicker.querySelectorAll(
			`[is="color-table-item"][data-tier-group="${this.dataset.tierGroup}"]`
		);
	}

	get siblings() {
		console.log(this.colorVariantPicker);
		return this.colorVariantPicker.querySelectorAll(`[is="color-table-item"]`);
	}

	get tieredPricing() {
		if (!this.hasTieredPricing) return;
		const pricing = JSON.parse(this.dataset.tieredPricing);

		const quantity = this.getTierGroupTotalQuantity();
		const tier =
			quantity === 0
				? pricing[0]
				: pricing.find(
						(t) =>
							quantity >= t.minQuantity &&
							(!t.maxQuantity || quantity <= t.maxQuantity)
				  );

		Logger.info(`${this.name} > #tieredPricing`, tier);
		return tier;
	}

	getTierGroupTotalQuantity() {
		let totalQty = 0;
		this.tieredGroupItem.forEach((e) => {
			const qtyInput = e.querySelector("input[data-quantity]:not(:disabled)");
			if (qtyInput) totalQty += Number(qtyInput.value);
		});

		Logger.info(`${this.name} > #getTierGroupTotalQuantity:`, totalQty);
		return totalQty;
	}

	updatePrices() {
		Logger.info(`${this.name} > #updateTieredItemsPrices:`);
		this.siblings.forEach((e) => {
			// check if elem is mounted
			if (e.setPrice) {
				e.setPrice();
				e.dispatchCustomEvent();
			}
		});
	}

	setPrice() {
		this.price = this.hasTieredPricing
			? this.tieredPricing.price * 100
			: parseInt(this.price);
		this.priceDiv.textContent = money(this.price);
	}

	attributeChangedCallback(name, oldValue, newValue) {
		Logger.info(`${this.name} > attributeChangedCallback:`, name, newValue);
		//
		if (name === "data-reset") {
			this.form.reset();
		}
	}

	onSelect(log = true) {
		if (log)
			Logger.info(`${this.name} > #onSelect`, this.sizeSelect.selectedIndex);

		const seletedValueElem =
			this.sizeSelect.querySelectorAll("option")[this.sizeSelect.selectedIndex];

		if (seletedValueElem && seletedValueElem.dataset.tierGroup) {
			this.dataset.tierGroup = seletedValueElem.dataset.tierGroup;
		} else {
			delete this.dataset.tierGroup;
		}

		const selectValues = this.sizeSelect.value.split("|");
		this.variantID = selectValues[0];
		const available = selectValues[2] === "true";
		this.dataset.otherOption = selectValues[3];

		if (selectValues[4]) {
			this.dataset.tieredPricing = selectValues[4];
		} else {
			delete this.dataset.tieredPricing;
		}
		this.quantityInput.disabled = !available;
		this.quantity = this.quantityInput.value
			? parseInt(this.quantityInput.value)
			: 0;

		this.price = this.hasTieredPricing
			? this.tieredPricing.price * 100
			: parseInt(selectValues[1]);

		this.priceDiv.textContent = money(this.price);

		if (this.quantity) {
			if (!available) this.quantity = 0;
		}

		this.updatePrices();
	}

	onInput() {
		Logger.info(`${this.name} > #onInput`, this.quantityInput.value);
		this.quantity = this.quantityInput.value
			? parseInt(this.quantityInput.value)
			: 0;

		this.priceDiv.textContent = money(
			this.hasTieredPricing
				? this.tieredPricing.price * 100
				: parseInt(this.price)
		);

		this.updatePrices();
	}

	dispatchCustomEvent() {
		const event = new CustomEvent("color-table-item:event", {
			detail: {
				quantity: this.quantity,
				price: Math.floor(this.quantity * this.price),
				id: this.variantID,
				option: this.dataset.colorOption,
				otherOption: this.dataset.otherOption,
				tieredPricing: this.hasTieredPricing
					? this.dataset.tieredPricing
					: undefined,
			},
		});
		this.dispatchEvent(event);
	}

	onSwatch() {
		if (
			this.modal &&
			this.swatchEl.dataset.style === "pattern" &&
			this.swatchEl.dataset.patternStyle !== "none"
		) {
			this.modalImage.src = this.swatchEl.dataset.patternStyle
				.replace("background-image: url(", "")
				.replace("width=284);", "width=680");
			this.modal.dataset.show = true;
		}
	}
}

customElements.define("color-table-item", ColoTableItem, { extends: "li" });
